"use client";

import Link from "next/link";

import type { FramerImageVariable, HeaderLogoVariant } from "./types";

import LogoFramerComponent from "@/framer/header-navbar/logo";

export interface HeaderLogoProps {
	variant?: HeaderLogoVariant;
	imageVariable?: FramerImageVariable;
	href?: string;
	ariaLabel?: string;
}

export function HeaderLogo({
	variant = "Variant 1",
	imageVariable,
	href,
	ariaLabel = "Home",
}: HeaderLogoProps) {
	const logo = (
		<LogoFramerComponent.Responsive
			variants={{ base: variant }}
			imageVariable={imageVariable}
		/>
	);

	if (!href) return logo;

	return (
		<Link href={href} className="contents" aria-label={ariaLabel}>
			{logo}
		</Link>
	);
}
